<template>
  <div class="modal-mask">
    <div class="card">
      <span class="title">Assign Rider</span>
      <p class="descMsg">
        Show tests for appointment # {{ appointment.id }} , created by
        {{ appointment.patient.name }}
      </p>

      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Name</th>
            <th scope="col">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-bind:key="item.id" v-for="item in appointment.tests">
            <th scope="row">{{ item.id }}</th>
            <td>{{ item.name }}</td>
            <td style="text-transform: capitalize">
              {{ item.status.replaceAll("_", " ") }}
            </td>
          </tr>
        </tbody>
      </table>

      <div class="actions">
        <button
          @click="$emit('dismiss')"
          class="btn btn-primary w-100 font-weight-bold"
        >
          Dismiss
        </button>
      </div>
    </div>
  </div>
</template>

<script>
var NotificationsController = require("./NotificationsController");
import { HTTP, URLS } from "../network/http";
export default {
  name: "AppointmentTestsComponent",
  props: ["appointment"],
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;

  .card {
    width: 70%;
    min-height: 50vh;
    max-height: 80vh;
    background-color: white;
    border-radius: 4px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: stretch !important;

    .title {
      width: 100%;
      line-height: 50px;
      font-size: 20px;
      color: black;
      font-weight: bold;
    }

    .descMsg {
      width: 100%;
      font-size: 14px;
      color: rgb(112, 53, 53);
    }

    .form {
      max-height: calc(100% - 200px);
      width: 100%;
      display: flex;
      flex-direction: column;
      overflow-y: scroll;
    }

    .actions {
      height: 50px;
      width: 100%;
      display: flex;
      flex-direction: row;
      margin-top: auto;
    }
  }
}
</style>